import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle, setDataModal, 
    FetchData, Helpers,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const {setModalOpeningMode} = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickNextStep = () => {

        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode} = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickShowLogBook = (idcredito) => {
        const { setShowLogBook} = globalStates
        const { FormRequestGlobal: {setFormState} } = Forms

        const {fetchInfoLogBook:{executeFetchInfoLogBook}} = FetchData

        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito
        }))

        setShowLogBook(true)
        executeFetchInfoLogBook()
    }

    const handleClickShowExpenses = (idcredito) => {
        const { setShowExpenses} = globalStates
        const { FormRequestGlobal: {setFormState} } = Forms

        const {fetchAllLegalExpenses:{executeFetchAllLegalExpenses}} = FetchData

        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito
        }))

        setShowExpenses(true)
        executeFetchAllLegalExpenses()
    }

    const handleClickHideForm = () => {

        const {setShowForm, setStepApplilication} = globalStates
        

        const { FormRequestGlobal : {onResetForm}} = Forms

        onResetForm()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickFetchInfoApplication = async (idcredito, idcotizacion, idvehiculo, modeOpening) => {
        
        const { FormRequestGlobal: {onResetForm, setFormState,formState}} = Forms
        const { 
            fetchAllVehicles:{executeFetchAllVehicles}, 
            fetchInfoCredit:{executeFetchInfoCredit},
            fetchAllQuotes:{executeFetchAllQuotes},
            fetchInfoQuotes:{executeFetchInfoQuote},
            fetchAllFiles:{executeFetchAllFiles},
            fetchAllDeposits:{executeFetchAllDeposits},
            fetchInfoDebtsSummary:{executeFetchDebtsSummary}
        } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito,
            idcotizacion: idcotizacion,
            idvehiculo: idvehiculo,
        }))

        executeFetchAllVehicles()
        executeFetchInfoCredit()
        executeFetchAllQuotes()
        executeFetchInfoQuote()
        executeFetchAllFiles()
        executeFetchAllDeposits()
        executeFetchDebtsSummary()
        handleClickShowForm(modeOpening)

    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {
        
        const { FormDeposit: {onResetForm}} = Forms


        const { fetchInfoDeposit:{setParamsToSearch, executeFetchInfoDeposit} } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({iddeposit: iddeposit})
        executeFetchInfoDeposit()


        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickCloseModal = () => {
        
        //HOOKS
        const { FormDeposit, FormPreInvventory, FormExpenses } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormInvventory = FormPreInvventory.onResetForm
        const onResetFormExpenses = FormExpenses.onResetForm

        onResetForm()
        onResetFormInvventory() 
        onResetFormExpenses()
        closeModal()
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');
    
          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }
    
    }

    const handleClickFetchInfoPreInventory = async (idvehicledeposit, modeOpening) => {
        
        const { FormPreInvventory: {onResetForm}} = Forms

        const { fetchInfoPreInventory : {setParamsToSearch, executeFetchPreInventory} } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idvehicledeposit: idvehicledeposit})
        executeFetchPreInventory()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de Pre Inventario', 'preinventory-section', {}, modeOpening)

    }

    const onSendLog = async () => {
        const { FormLogBook:{formState, onResetForm}, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const {fetchInfoLogBook:{executeFetchInfoLogBook}} = FetchData

        const {getCurrentDate} = Helpers

        const _data = new FormData();

        _data.append('idcredito', formStateGlobal.idcredito);
        _data.append('idusuario', user.uid);
        _data.append('fecha_bitacora', getCurrentDate());
        _data.append('descripcion', formState.descripcion);
        _data.append('vigencia_credito', "COBRO EXTRAJUDICIAL"); // TODO: Actualizar estado


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if(formStateGlobal.idcredito>0){
            
            await marvarApi.post( `/vehicle/legal-credits/create-log-entry`, _data )
                .then(async ({ data }) => {
                    
                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchInfoLogBook()
                    }
                    })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
                    
        }

    }


    const handleClickFetchInfoExpenses = async () => {

        handleClickShowModal('', 'Formulario de gastos', 'expenses-section', {}, 'EDITABLE')

    }

    const onSubmitFormExpenses = async (e) => {

        e.preventDefault()
    
        const { FormExpenses: { formState, onResetForm, setFormState }, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const {getCurrentDate} = Helpers
    
        const {fetchAllLegalExpenses:{executeFetchAllLegalExpenses}} = FetchData

        if(formStateGlobal.idcredito>0){

            const body = {
                idusuario: user.uid,
                gasto_fecha: formState.gasto_fecha,
                gasto_descripcion: formState.gasto_descripcion,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate(),
                gasto_monto: formState.clean_gasto_monto
            }

            await marvarApi.post( `/vehicle/common/create-expense/${formStateGlobal.idcredito}`, body )
            .then(({ data }) => {
    
                alertMessage(data)
    
                if (data.title === 'OK') {
                    onResetForm()
                    executeFetchAllLegalExpenses()
                    closeModal()
                }
                
            })
            .catch(error => {
                    console.log('API ERROR: ', error)
            })
        }
    }

    const handleButtonDeleteExpenses = (idgasto) => {

        const {fetchAllLegalExpenses:{executeFetchAllLegalExpenses}} = FetchData

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            text: 'Esta acción elimara el gasto asociado al credito de vehiculo',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/legal-credits/delete-expense/${idgasto}`)
                .then( async ({ data }) => {
                    alertMessage(data)
                    executeFetchAllLegalExpenses()
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickCloseExpenses = () => {

        const {setShowExpenses} = globalStates

        const {FormExpenses:{onResetForm}} = Forms
        
        onResetForm()

        setShowExpenses(false)
    
    }

    const handleClickCloseLogs = () => {

        const {setShowLogBook} = globalStates

        const {FormLogBook:{onResetForm}} = Forms
        
        onResetForm()

        setShowLogBook(false)
    
    }

    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        handleClickShowLogBook,
        handleClickShowExpenses,
        handleClickFetchInfoApplication,
        handleClickNextStep,
        handleClickReturnStep,
        handleClickFetchInfoDeposit,
        handleClickShowModal,
        handleClickCloseModal,
        handleClickDownloadImage,
        handleClickFetchInfoPreInventory,
        handleClickFetchInfoExpenses,
        onSubmitFormExpenses,
        handleButtonDeleteExpenses,
        onSendLog,
        handleClickCloseExpenses,
        handleClickCloseLogs,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}